// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"10ead536","455":"2eec1e07","644":"fbe79574"}[chunkId] + ".chunk.js";
};